export const CURRENT_USER_ID = 'profile';
